import styled from 'styled-components';

export default styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: ${props => props.backdropColor};
  opacity: 0.2;
`;
